import React from "react";
import { LegendOrdinal } from "@visx/legend";
import { scaleOrdinal } from "@visx/scale";
import PerfectScrollbar from "react-perfect-scrollbar";

export default function GraphicsLegend({ colors, labels }) {
  const colorScale = scaleOrdinal({
    domain: labels,
    range: colors,
  });
  return (
    <div
      className="my-3"
      style={{
        display: "flex",
        flexDirection: "column",

        gap: "0.2rem",
        marginTop: "0px",
      }}
    >
      <PerfectScrollbar className="w-100 d-flex flex-column gap-2" style={{ maxHeight: "13rem" }}>
        <LegendOrdinal scale={colorScale} labelFormat={(label) => `${label}`}>
          {(labels) =>
            labels.map((label, i) => (
              <div
                key={`legend-${i}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.7rem",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: (label?.value as string) || "#ccc",
                    borderRadius: "50%",
                  }}
                />
                <span style={{width: "80%" }}>{label.text}</span>
              </div>
            ))
          }
        </LegendOrdinal>
      </PerfectScrollbar>
    </div>
  );
}
